import React, {Component} from "react";
import translate from "./i18n";
import globals from "./globals";
let userLang = navigator.language || navigator.userLanguage;

// All components inherit from BaseComponent to get this.globs.  this.globs is a legacy project super global which I can maybe update later all the callers, but I dont feel like it now.
const $ = window;

class BaseComponent extends Component {
  constructor(props, context) {
    super(props, context);
    let transKey = "en";
    if (userLang.indexOf("en") === -1) {
      transKey = "jp";
    }
    this.user = $.user;
    this.lang = transKey;
    this.translate = translate[transKey];
    this.globs = globals;
    this.setupSiteSpecificFunctions();
  }

  setupSiteSpecificFunctions = () => {
    this.globs.ComponentError = (classname, message, e = null) => {
      let stack = null;
      try {
        stack = (e !== null && e !== undefined) ? e.stack : null;
      } catch (ee) {}
      this.globs.log("ComponentError: " + classname + " errored with", message, stack);
      return <div className="example" style={{ margin: 15, backgroundColor: "orange"}}>
        <div className="step error" style={{ backgroundColor: "orange"}}>
          <span className="step-number">!</span>
          <div className="step-desc">
            <span className="step-title">Error</span>
            <pre className="stacktrace">{stack}</pre>
          </div>
        </div>
      </div>
    };

    this.globs.log = function() {
      console.debug("");
      var colors = "background: #222; color: #bada55";
      console.debug("%c!!!!!!!!!!!!! DEBUG !!!!!!!!!!!!!", colors);
      console.debug(new Error().stack);
      for (var i = 0; i < arguments.length; ++i) {
        console.debug("%cParm" + i + ":", colors, arguments[i]);
      }
      console.debug("%c!!!!!!!!!!!!! ENDDEBUG !!!!!!!!!!!!!", colors);
      console.debug("");
    };
  }
}

export default BaseComponent;



// WEBPACK FOOTER //
// ./src/components/system/base.js